import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstanceJson from "../../../AxiosInstance/axiosInstanceJson";

export const createBloodGroup = createAsyncThunk(
  "BloodGroup/createBloodGroup",
  async (bloodGroupData, { rejectWithValue }) => {
    try {
      const response = await axiosInstanceJson.post(
        `/v1/admin/bloodGroup/create-bloodGroup`,
        bloodGroupData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getBloodGroup = createAsyncThunk(
  "BloodGroup/getAll",
  async (
    {
      id,
      status = "All",
      search = "",
      page = 1,
      limit = 10,
      startDate,
      endDate,
      paginate,
    },
    thunkAPI
  ) => {
    try {
      const { data } = await axiosInstanceJson.get(
        `/v1/admin/bloodGroup/get-bloodGroup`,
        {
          params: {
            id,
            status,
            search,
            page,
            limit,
            startDate,
            endDate,
            paginate,
          },
        }
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Error occurred");
    }
  }
);

export const deleteBloodGroup = createAsyncThunk(
  "BloodGroup/delete",
  async (id, thunkAPI) => {
    try {
      const { data } = await axiosInstanceJson.put(
        `/v1/admin/bloodGroup/delete-bloodGroup/${id}`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const undoDeleteBloodGroup = createAsyncThunk(
  "BloodGroup/undoDelete",
  async (id, thunkAPI) => {
    try {
      const { data } = await axiosInstanceJson.put(
        `/v1/admin/bloodGroup/undodelete-bloodGroup/${id}`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getBloodGroupById = createAsyncThunk(
  "BloodGroup/getById",
  async (id, thunkAPI) => {
    try {
      const { data } = await axiosInstanceJson.get(
        `/v1/admin/bloodGroup/getSingle-bloodGroup/${id}`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const updateBloodGroup = createAsyncThunk(
  "BloodGroup/update",
  async ({ _id, formData }, thunkAPI) => {
    try {
      const response = await axiosInstanceJson.put(
        `/v1/admin/bloodGroup/update-bloodGroup/${_id}`,
        formData
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);
